"use strict";

export default ({ app, store }, inject) => {
  inject("snackbar", {
    showMessage({ content = "", color = "", error }) {
      if (error) {
        try {
          const errors = JSON.parse(error.request.response).errors;
          for (const err of errors) {
            content += "<br>" + err.msg;
          }
        } catch (error) {}
      }
      store.commit("snackbar/showMessage", { content, color });
    },
  });
};
